import { auth } from '../../config/firebase';
//import { createUserWithEmailAndPassword, updateProfile, signOut, signInWithEmailAndPassword } from 'firebase/auth'

import { createUserWithEmailAndPassword, signOut, signInWithEmailAndPassword } from 'firebase/auth'
import { serializeUser } from './serializeUser';


const register = async (email, parola, kullaniciAd) => {
    const userResponse = await createUserWithEmailAndPassword(auth, email, parola)
    /*
    await updateProfile({
        displayName: "displayName",
        photoURL: "displayName"
    })
    */
    const safeUser = serializeUser(userResponse.user);
    if (safeUser) {
        localStorage.setItem('user', JSON.stringify(safeUser))
    }
    return safeUser
}

const logout = async () => {
    await signOut(auth);
    localStorage.removeItem('user');
}

const login = async (email, parola) => {
    const userResponse = await signInWithEmailAndPassword(auth, email, parola)
    const safeUser = serializeUser(userResponse.user);
    if (safeUser) {
        localStorage.setItem('user', JSON.stringify(safeUser))
    }
    return safeUser
}

const loginotp = async (user) => {
    const safeUser = serializeUser(user);
    if (safeUser) {
        localStorage.setItem('user', JSON.stringify(safeUser))
    }
    return safeUser
}

const authService = {
    register,
    logout,
    login,
    loginotp,
}

export default authService
